import React from "react";

import {
  Switch,
  Route,
  Redirect,
  useRouteMatch,
  useHistory
} from "react-router-dom";

import Drawer from "./components/Drawer";

const Routes = () => {
  const history = useHistory();
  const { path } = useRouteMatch();
  // {/*<UserManagerDrawer />*/}

  return (
    <Switch>
      <Route exact path={`${path}/new`} render={() => (
        <Drawer
          visible={true}
          closeFunction={() => history.push(`${path}`)}
        />
      )} />
      <Route exact path={`${path}/edit/:id`} render={() => (
        <Drawer
          visible={true}
          closeFunction={() => history.push(`${path}`)}
          edit
        />
      )} />
      <Redirect to={`${path}`} />
    </Switch>
  );
}

export default Routes;